"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMain = exports.nftStorageClientContext = exports.anchorClientContext = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const class_map_js_1 = require("lit/directives/class-map.js");
const router_1 = require("@vaadin/router");
const context_1 = require("@lit/context");
const context_2 = require("@lit/context");
const anchorClient_1 = require("../lib/anchor/anchorClient");
const nftStorageClient_1 = require("../lib/nftStorageClient");
const defs_1 = require("../lib/defs");
// Providers
exports.anchorClientContext = (0, context_2.createContext)(Symbol("anchor-client"));
exports.nftStorageClientContext = (0, context_2.createContext)(Symbol("nft-storage"));
// App Main
let AppMain = (() => {
    var _AppMain_anchorClient_accessor_storage, _AppMain_nftStorageClient_accessor_storage;
    let _classDecorators = [(0, decorators_js_1.customElement)("app-main")];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = lit_1.LitElement;
    let _instanceExtraInitializers = [];
    let _anchorClient_decorators;
    let _anchorClient_initializers = [];
    let _nftStorageClient_decorators;
    let _nftStorageClient_initializers = [];
    var AppMain = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _AppMain_anchorClient_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _anchorClient_initializers, null)));
            _AppMain_nftStorageClient_accessor_storage.set(this, __runInitializers(this, _nftStorageClient_initializers, new nftStorageClient_1.NFTStorageClient({
                token: defs_1.NFT_STORAGE_TOKEN,
            })));
        }
        // Providers
        get anchorClient() { return __classPrivateFieldGet(this, _AppMain_anchorClient_accessor_storage, "f"); }
        set anchorClient(value) { __classPrivateFieldSet(this, _AppMain_anchorClient_accessor_storage, value, "f"); }
        get nftStorageClient() { return __classPrivateFieldGet(this, _AppMain_nftStorageClient_accessor_storage, "f"); }
        set nftStorageClient(value) { __classPrivateFieldSet(this, _AppMain_nftStorageClient_accessor_storage, value, "f"); }
        // Setup router
        firstUpdated() {
            var _a;
            const router = new router_1.Router((_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector("#page-route"));
            router.setRoutes([
                { path: "/game", component: "game-page" },
                { path: "(.*)", component: "onboard-player-page" }, // default onboard player
            ]);
        }
        onConnectWallet(e) {
            return __awaiter(this, void 0, void 0, function* () {
                const { wallet, anchorWallet } = e.detail;
                if (wallet && anchorWallet) {
                    // Create AnchorClient
                    this.anchorClient = new anchorClient_1.AnchorClient({
                        wallet: wallet,
                        anchorWallet: anchorWallet,
                    });
                    console.log(`app-main::onConnectWallet:: ${e.detail.anchorWallet.publicKey}`);
                }
            });
        }
        onDisconnectWallet(e) {
            this.anchorClient = null;
            console.log(`app-main::onDisconnectWallet`);
        }
        getContent() {
            return (0, lit_1.html) `
      <!-- Show page-route if there wallet is connected -->
      <div
        id="page-route"
        class=${(0, class_map_js_1.classMap)({ hidden: !Boolean(this.anchorClient) })}
      ></div>
      <!-- Show onboard-wallet-page if wallet is not connected -->
      <onboard-wallet-page
        class=${(0, class_map_js_1.classMap)({ hidden: Boolean(this.anchorClient) })}
        @on-connect-wallet=${this.onConnectWallet}
        @on-disconnect-wallet=${this.onDisconnectWallet}
      ></onboard-wallet-page>
    `;
        }
        render() {
            return (0, lit_1.html) `
      <!-- Header -->
      <app-header-layout>
        <app-header slot="header" fixed>
          <app-toolbar class="toolbar">
            <div main-title>Yggdrasil</div>
            <!-- Show disconnect if wallet is connected -->
            <sl-button
              variant="danger"
              outline
              class=${(0, class_map_js_1.classMap)({ hidden: !Boolean(this.anchorClient) })}
              @click="${() => {
                var _a;
                (_a = this.anchorClient) === null || _a === void 0 ? void 0 : _a.wallet.adapter.disconnect();
                this.anchorClient = null;
            }}"
              >Disconnect</sl-button
            >
          </app-toolbar>
        </app-header>
        <!-- Content -->
        <div class="app-body">${this.getContent()}</div>
      </app-header-layout>
    `;
        }
    };
    _AppMain_anchorClient_accessor_storage = new WeakMap();
    _AppMain_nftStorageClient_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "AppMain");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _anchorClient_decorators = [(0, context_1.provide)({ context: exports.anchorClientContext }), (0, decorators_js_1.state)()];
        _nftStorageClient_decorators = [(0, context_1.provide)({ context: exports.nftStorageClientContext }), (0, decorators_js_1.state)()];
        __esDecorate(_classThis, null, _anchorClient_decorators, { kind: "accessor", name: "anchorClient", static: false, private: false, access: { has: obj => "anchorClient" in obj, get: obj => obj.anchorClient, set: (obj, value) => { obj.anchorClient = value; } }, metadata: _metadata }, _anchorClient_initializers, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _nftStorageClient_decorators, { kind: "accessor", name: "nftStorageClient", static: false, private: false, access: { has: obj => "nftStorageClient" in obj, get: obj => obj.nftStorageClient, set: (obj, value) => { obj.nftStorageClient = value; } }, metadata: _metadata }, _nftStorageClient_initializers, _instanceExtraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        AppMain = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = (0, lit_1.css) `
    .hidden {
      display: none;
    }
    .toolbar {
      background-color: rgba(255, 255, 255, 0.95);
    }
    app-footer::part(bottom-nav) {
      background-color: rgba(255, 255, 255, 0.95);
    }
    .app-body {
      margin-bottom: 50px;
    }
  `;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return AppMain = _classThis;
})();
exports.AppMain = AppMain;
